import { DIALOG_TYPE, LayoutConfig, SpinnerComponent } from "@spartacus/storefront";


export const defaultSpinnersLayoutConfig: LayoutConfig = {
  launch: {
    VALIDATE_CART_SPINNER: {
      inline: true,
      component: SpinnerComponent,
      dialogType: DIALOG_TYPE.POPOVER_CENTER_BACKDROP,
    },
    PAYPAL_ACTIONS_SPINNER: {
      inline: true,
      component: SpinnerComponent,
      dialogType: DIALOG_TYPE.POPOVER_CENTER_BACKDROP,
    },
    ORDER_ACTIONS_SPINNER: {
      inline: true,
      component: SpinnerComponent,
      dialogType: DIALOG_TYPE.POPOVER_CENTER_BACKDROP,
    },
  },
};

